/**
 * @author Petr Mikušek <petr.mikusek@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import Queue from '../queue/queue';
import { assertIsServerDeviceId } from '../session/session-attrs';

/**
 * @import { ISession, MutexContext } from '.'
 * @import Store from '../store/store'
 */

/**
 * Úložiště analytických dat s mutexem.
 */
export default class AnalyticsStore {
  /**
   * @param {ISession} session
   * @param {Store} store Datový sklad s analytickými daty.
   */
  constructor(session, store) {
    /** @private */
    this.session = session;
    /** @private Zásadně nepoužívat napřímo, jen předávat do {@link doInMutex}! */
    this.store = store;

    /** @private Mutex pro JSData operace nad Analytics{Counter,Group}. */
    this.mutex = new Queue();
  }

  // TODO: Předávání AbortSignal do handleru.
  /**
   * @param {(ctx: MutexContext) => (void | PromiseLike<void>)} handler
   * @throws {Error} {@link assertIsServerDeviceId}
   */
  async doInMutex(handler) {
    // TODO: Pokud je zaručeno, že se Session před prvním volání naplní a nezmění,
    // tak by šla kontrola udělat jednou a lazy.
    assertIsServerDeviceId(this.session);
    const { deviceId, serverUrl } = this.session;
    const serverDeviceId = { deviceId, serverUrl };

    const { store } = this;
    await this.mutex.enqueue(() => handler({ serverDeviceId, store }));
  }

  reset() {
    this.mutex.clear();
  }
}
